import layout from './layout'

export default {
  namespaced: true,
  modules: {
    layout
  }
}
